@if (showAliceButton && showAlicePage) {
  <button class="fut-btn fut-btn-lg alice-btn" [ngClass]="{ opened: isOpen }" (click)="open()">
    <!-- <mat-icon fontSet="material-symbols-outlined">auto_awesome</mat-icon> -->
    <div class="avatar-container">
      <app-alice-animations [type]="'static'"></app-alice-animations>
    </div>
    <span>{{ 'alice.button.title' | transloco }}</span>
  </button>
}
